const appConfig = {
  recaptchaClientKey: process.env.REACT_APP_RECAPTCHA_CLIENT_KEY || '',
  gqlEndpoint: process.env.REACT_APP_GQL_ENDPOINT || '',
};

export default appConfig;
